import React from 'react';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { TextInput, BooleanInput, DateInput } from 'components/input';

import {
  DisabledInputOptions,
} from 'util/constants';

import * as urls from './urls';


export const ShopLoginWhitelistEdit = (props) => (
  <Edit editBackendPath={urls.shopLoginWhitelistEditBackendPath} updateDataOnMount={false} {...props}>
    <SimpleForm>
      <TextInput options={DisabledInputOptions} source='id' label='ID' isRequired={true}/>
      <TextInput options={DisabledInputOptions} source='shop_id' label='Shop ID' isRequired={true}/>
      <TextInput source='reason' label='Reason' isRequired={true}/>
      <DateInput source='expiry_time' label='Expiry Time' isRequired={true}/>
      <BooleanInput source='status' label="Status" isRequired={true}/>
    </SimpleForm>
  </Edit>
);


// WEBPACK FOOTER //
// ./src/routes/shop/ShopLoginWhitelistEdit.js